/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ObservationTimeSeriesPeriod = {
    NotSpecified: 'NotSpecified',
    Year: 'Year',
    Month: 'Month',
    Day: 'Day',
    Hour: 'Hour',
    Quarter: 'Quarter',
    Other: 'Other',
} as const;
export type ObservationTimeSeriesPeriod = typeof ObservationTimeSeriesPeriod[keyof typeof ObservationTimeSeriesPeriod];

